import React, {useEffect} from 'react';
import type {WithRouterProps} from 'react-router';
import {withRouter} from 'react-router';

import {LoadingSpinner} from '@albert-io/atomic';
import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';

import {TeacherDashboard} from './TeacherDashboard';

/** Renders the teacher dashboard when teacher_dashboard_v2 is on, otherwise redirects to the legacy landing page. */
const TeacherDashboardGate = withRouter(({location, router}: WithRouterProps<{}>) => {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('teacher_dashboard_v2');

  const pathname = location?.pathname ?? '/home';

  useEffect(() => {
    if (isLoading) {
      return;
    }
    if (!isFeatureEnabled) {
      router.replace('/classes');
    } else if (pathname !== '/home') {
      // Student child routes (/home/assignments etc.) have no teacher equivalent.
      router.replace('/home');
    }
  }, [isFeatureEnabled, isLoading, pathname, router]);

  if (isLoading || !isFeatureEnabled) {
    return <LoadingSpinner />;
  }

  return <TeacherDashboard location={location} />;
});

export default TeacherDashboardGate;
